<script>
    import {onMount} from "svelte";
    import {push} from "svelte-spa-router";

    export let audioGuide;

    import {querystring} from "svelte-spa-router";


    onMount(() => {
        console.log("Code found");
        if(audioGuide.code == undefined) return;
        const audioGuideCodeId = audioGuide.id + "-code";
        const audioGuideCode = window.localStorage.getItem(audioGuideCodeId);
        let unsub = querystring.subscribe((value) => {
            console.log(value)
            const params = new URLSearchParams(value);
            let code = params.get("code");
            console.log("Code: " + code);
            console.log("AudioGuideCode: " + audioGuideCode);
            console.log("test", audioGuide.code)
            if((audioGuideCode == undefined && code == undefined ) || !(audioGuide.code.toLowerCase() == audioGuideCode?.toLowerCase() || code?.toLowerCase() == audioGuide.code.toLowerCase())) {
                console.log("Redirecting");
                window.localStorage.removeItem(audioGuideCodeId);
                push("/audio-guide-entry/" + audioGuide.id);
            }
        });
    })
</script>
